import { useMemo } from "react";
import useSWR, { mutate } from "swr";

export const endpoints = {
  key: "snackbar",
};

const initialState = {
  action: false,
  open: false,
  message: "Note archived",
  anchorOrigin: {
    vertical: "top",
    horizontal: "right",
  },
  variant: "default",
  alert: {
    color: "primary",
    variant: "standard",
  },
  transition: "SlideLeft",
  close: true,
  actionButton: false,
  // Optional navigate-style action (e.g. "Voir" -> an admin detail page).
  // Distinct from actionButton/"Annuler" above, which just closes.
  actionLabel: undefined,
  onAction: undefined,
  maxStack: 3,
  dense: false,
  iconVariant: "usedefault",
  autoHideDuration: 2500,
};

export function useGetSnackbar() {
  const { data } = useSWR(endpoints.key, () => initialState, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    fallbackData: initialState,
  });

  const memoizedValue = useMemo(() => ({ snackbar: data ?? initialState }), [data]);

  return memoizedValue;
}

export function openSnackbar(snackbar) {
  // to update local state based on key

  const {
    action,
    open,
    message,
    anchorOrigin,
    variant,
    alert,
    transition,
    close,
    actionButton,
    actionLabel,
    onAction,
    autoHideDuration,
  } = snackbar;

  mutate(
    endpoints.key,
    (currentSnackbar) => {
      return {
        ...currentSnackbar,
        action: action || initialState.action,
        open: open || initialState.open,
        message: message || initialState.message,
        anchorOrigin: anchorOrigin || initialState.anchorOrigin,
        variant: variant || initialState.variant,
        alert: {
          color: alert?.color || initialState.alert.color,
          variant: alert?.variant || initialState.alert.variant,
        },
        transition: transition || initialState.transition,
        close: close || initialState.close,
        actionButton: actionButton || initialState.actionButton,
        // Not previous-call-fallback'd the same way — a stale onAction from
        // an earlier toast must never survive onto one that didn't ask for
        // it, so these always reset to whatever this call passed (possibly
        // undefined), never to currentSnackbar's leftover value.
        actionLabel,
        onAction,
        autoHideDuration: autoHideDuration || initialState.autoHideDuration,
      };
    },
    false,
  );
}

export function closeSnackbar() {
  // to update local state based on key
  mutate(
    endpoints.key,
    (currentSnackbar) => {
      return { ...currentSnackbar, open: false };
    },
    false,
  );
}

export function handlerIncrease(maxStack) {
  // to update local state based on key
  mutate(
    endpoints.key,
    (currentSnackbar) => {
      return { ...currentSnackbar, maxStack };
    },
    false,
  );
}

export function handlerDense(dense) {
  // to update local state based on key
  mutate(
    endpoints.key,
    (currentSnackbar) => {
      return { ...currentSnackbar, dense };
    },
    false,
  );
}

export function handlerIconVariants(iconVariant) {
  // to update local state based on key
  mutate(
    endpoints.key,
    (currentSnackbar) => {
      return { ...currentSnackbar, iconVariant };
    },
    false,
  );
}
